import { render } from "./categoryEdit.vue?vue&type=template&id=906e6cb6"
import script from "./categoryEdit.vue?vue&type=script&lang=js"
export * from "./categoryEdit.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\webencusco\\projects\\admin-carta\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__